import { CONSTANT } from "src/app/constant";
import { Roles } from "src/app/models/enum";
import { isCabinCrewInstructorRole, isCabinCrewRole, isInstructorViewRole, isPilotViewRole } from "./user-role-view.utils";

const FLIGHT_FORM_TYPES = [
	CONSTANT.FORM_TYPE.ts_1,
	CONSTANT.FORM_TYPE.ts_3,
	CONSTANT.FORM_TYPE.ts_5,
	CONSTANT.FORM_TYPE.ts_6,
];

const CABIN_FORM_TYPES = [CONSTANT.FORM_TYPE.cabin_crew, CONSTANT.FORM_TYPE.cabin_crew_instructor];

const ADMIN_ROLES = new Set<string>([Roles.ADMIN, Roles.OFFICE_ADMIN, Roles.GROUP_ADMIN]);

export function formTypesVisibleToRole(role: string | null | undefined): string[] {
	const normalized = (role ?? "").trim().replace(/\s+/g, " ").toLowerCase();

	if (ADMIN_ROLES.has(normalized)) {
		return [...FLIGHT_FORM_TYPES, ...CABIN_FORM_TYPES];
	}

	if (isCabinCrewRole(normalized)) {
		return [CONSTANT.FORM_TYPE.cabin_crew];
	}

	if (isCabinCrewInstructorRole(normalized)) {
		return [...CABIN_FORM_TYPES];
	}

	if (isPilotViewRole(normalized) || isInstructorViewRole(normalized)) {
		return [...FLIGHT_FORM_TYPES];
	}

	return [];
}

export function isFormTypeVisibleToRole(formType: string | null | undefined, role: string | null | undefined): boolean {
	const code = (formType ?? "").trim().toLowerCase();
	if (!code) {
		return false;
	}
	return formTypesVisibleToRole(role).includes(code);
}

export function filterOptionsByRole<T extends { value: string }>(options: T[], role: string | null | undefined): T[] {
	const allowed = new Set(formTypesVisibleToRole(role));
	return options.filter((option) => allowed.has(option.value));
}
